import Script from "next/script";

export default function Ad_320x50(props) {
  return (
    <div className="Ad_300x100" id={props.id}>
      <div className="Horizon_auto">
        {/* Google AdSense Script */}
        <Script
          strategy="lazyOnload"
          src="https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-2622226100196993"
          crossOrigin="anonymous"
        />
        {/* Google AdSense Ad Slot */}
        <ins
          className="adsbygoogle"
          style={{display:"inline-block",width:"320px",height:"50px"}}
          data-ad-client="ca-pub-2622226100196993"
          data-ad-slot="8977824082"
        ></ins>
        <Script id="adsbygoogle-init" strategy="lazyOnload">
          {`(adsbygoogle = window.adsbygoogle || []).push({});`}
        </Script>
      </div>
    </div>
  );
}
